import React, { useState, useEffect } from 'react';
import { YAxisMouseOver, YAxisMouseOverState } from './YAxisMouseOver';
import styleConstants from './variables.module.scss';

const tooltipOffset = parseInt(styleConstants.tooltipOffset);

export interface PortfolioSummaryChartYAxisTooltipProps {
    yAxisMouseOver: YAxisMouseOver;
}

export const showDelay = 1000;

export function PortfolioSummaryChartYAxisTooltip(
    props: PortfolioSummaryChartYAxisTooltipProps
) {
    const { yAxisMouseOver } = props;

    const [yAxisMouseOverState, setyAxisMouseOverState] =
        useState<YAxisMouseOverState>({});

    const [visible, setVisible] = useState(false);
    const [showVisibleTimer, setShowVisibleTimer] = useState<
        NodeJS.Timeout | undefined
    >(undefined);

    function clearShowVisibleTimer() {
        if (showVisibleTimer) {
            clearTimeout(showVisibleTimer);
        }
        setShowVisibleTimer(undefined);
    }

    useEffect(() => {
        yAxisMouseOver.subscribe('PortfolioSummaryChartYAxisTooltip', (s) => {
            setyAxisMouseOverState(s || {});
            if (s?.text && !showVisibleTimer) {
                // Show the tooltip after a second...
                const timer = setTimeout(() => {
                    setVisible(true);
                    clearShowVisibleTimer();
                }, showDelay);
                setShowVisibleTimer(timer);
            }
            if (!s?.text) {
                setVisible(false);
                clearShowVisibleTimer();
            }
        });
    });

    const style: React.CSSProperties = {
        top: yAxisMouseOverState.y && yAxisMouseOverState.y - tooltipOffset,
        left: yAxisMouseOverState.x,
        visibility: yAxisMouseOverState.text && visible ? 'visible' : 'hidden',
    };
    const text = yAxisMouseOverState.text ?? '';

    return (
        <div className="PortfolioSummaryChartYAxisTooltip" style={style}>
            {text}
        </div>
    );
}
